import React from 'react'
import { Link, graphql } from 'gatsby'
import DefaultLayout from '../components/layout'
import SEO from '../components/seo'
import BlogListItem from './blog-list-item'
// import loadable from '@loadable/component'

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges
    const { currentPage, numPages } = this.props.pageContext
    const isFirst = currentPage === 1
    const isLast = currentPage === numPages
    const prevPage = currentPage - 1 === 1 ? '/' : (currentPage - 1).toString()
    const nextPage = (currentPage + 1).toString()

    return (
      <DefaultLayout>
        <SEO
          title={siteTitle}
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        {posts.map(({ node }, index) => {
          return (
            <BlogListItem key={index} node={node} />
          )
        })}

        <div className="container">
          <nav className="pagination" role="pagination">
            <div>
              {!isFirst && (
                <p>
                  <Link
                    to={prevPage}
                    rel="link"
                    className="newer-posts"
                    aria-label="ir para a pagina anterior"
                  >
                    ← Página anterior
                  </Link>
                </p>
              )}
              <p>
                <span className="page-number">
                  Página {currentPage} de {numPages}
                </span>
              </p>
              {!isLast && (
                <p>
                  <Link
                    to={nextPage}
                    rel="link"
                    className="older-posts"
                    aria-label="ir para a proxima pagina"
                  >
                    Próxima página →
                  </Link>
                </p>
              )}
            </div>
          </nav>
        </div>
      </DefaultLayout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query blogPageQuery($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {frontmatter: { published: {eq: true} }}
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          timeToRead
          frontmatter {
            date(formatString: "DD/MM/YYYY")
            tags
            title
            img {
              childImageSharp {
                fluid(maxWidth: 3720) {
                  aspectRatio
                  base64
                  sizes
                  src
                  srcSet
                }
              }
            }
          }
        }
      }
    }
  }
`
